// extracted by mini-css-extract-plugin
module.exports = {"hover":"hover_hover__3JKMr","info":"hover_info__2-bRt","title":"hover_title__2gfzy","text":"hover_text__2s5qR","showing":"hover_showing__38ij8"};